function renderBuildFormDevModeSnippetsClientModuleTemplate({
  pascal,
  actionModulePath,
  tsObject,
  toLowerCase
}: {
  pascal: string
  actionModulePath: string
  tsObject: string
  toLowerCase: string
}): string {
  return `'use client'

import * as React from 'react'
import {
  create${pascal}Submission,
  type Create${pascal}SubmissionInput
} from '${actionModulePath}'

const input: Create${pascal}SubmissionInput = ${tsObject}

export function ${pascal}SubmitButton() {
  const [isPending, startTransition] = React.useTransition()

  return (
    <button
      type="button"
      disabled={isPending}
      onClick={() => {
        startTransition(async () => {
          await create${pascal}Submission(input)
        })
      }}
    >
      Submit ${toLowerCase}
    </button>
  )
}
`
}

function renderBuildFormDevModeSnippetsImportsTemplate({
  pascal,
  actionModulePath,
  toLowerCase
}: {
  pascal: string
  actionModulePath: string
  toLowerCase: string
}): string {
  return `import { get${pascal}Submissions } from '${actionModulePath}'

export default async function ${pascal}Submissions() {
  const { submissions, total } = await get${pascal}Submissions({ limit: 10, offset: 0 })

  return (
    <section>
      <h2>{total} ${toLowerCase} submissions</h2>
      <pre>{JSON.stringify(submissions, null, 2)}</pre>
    </section>
  )
}
`
}

function renderBuildFormDevModeSnippetsClientModuleDetailsTemplate({
  pascal,
  actionModulePath
}: {
  pascal: string
  actionModulePath: string
}): string {
  return `'use client'

import * as React from 'react'
import { delete${pascal}Submission } from '${actionModulePath}'

export function Delete${pascal}SubmissionButton({ id }: { id: string }) {
  const [isPending, startTransition] = React.useTransition()

  return (
    <button
      type="button"
      disabled={isPending}
      onClick={() => {
        startTransition(async () => {
          await delete${pascal}Submission(id)
        })
      }}
    >
      Delete submission
    </button>
  )
}
`
}

export function renderBuildFormDevModeSnippetsRenderer(
  request:
    | {
        kind: 'renderBuildFormDevModeSnippetsClientModuleTemplate'
        props: {
          pascal: string
          actionModulePath: string
          tsObject: string
          toLowerCase: string
        }
      }
    | {
        kind: 'renderBuildFormDevModeSnippetsImportsTemplate'
        props: {
          pascal: string
          actionModulePath: string
          toLowerCase: string
        }
      }
    | {
        kind: 'renderBuildFormDevModeSnippetsClientModuleDetailsTemplate'
        props: {
          pascal: string
          actionModulePath: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderBuildFormDevModeSnippetsClientModuleTemplate':
      return renderBuildFormDevModeSnippetsClientModuleTemplate(request.props)
    case 'renderBuildFormDevModeSnippetsImportsTemplate':
      return renderBuildFormDevModeSnippetsImportsTemplate(request.props)
    case 'renderBuildFormDevModeSnippetsClientModuleDetailsTemplate':
      return renderBuildFormDevModeSnippetsClientModuleDetailsTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
